import React from "react";

const ExportData = ({ apiData, fileName, fields }) => {
  const exportCSV = (ext = "csv") => {
    if (!apiData || apiData.length === 0) return;

    // Use fields if provided, else take all keys
    const headers = fields && fields.length > 0 
      ? fields 
      : Object.keys(apiData[0]);

    const rows = apiData.map(row =>
      headers.map(field => JSON.stringify(row[field] ?? "")).join(",")
    );

    const csvContent = [headers.join(","), ...rows].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.${ext}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="export-container">
      <button className="export-btn">Export ▼</button>
      <div className="dropdown">
        <button onClick={() => exportCSV("csv")}>CSV</button>
      </div>
    </div>
  );
};

export default ExportData;
